import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { LookupService } from "../services/lookup.service";
import { CommonDropDown, SingleCommonDropDown } from "../common/types/dropdown.type";

@Injectable({
    providedIn: 'root'
})
export class EducationDropDownResolver implements Resolve<SingleCommonDropDown[]> {
    /**
     * Constructor
     */
    constructor(private _lookupService: LookupService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SingleCommonDropDown[]> {
        return this._lookupService.getEducation();
    }
}